import React from 'react'
import { graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from '../components/layout'
import githubIcon from '../images/github-brands.svg'
import twitterIcon from '../images/twitter-square-brands.svg'
import linkedinIcon from '../images/linkedin-brands.svg'
import './styles/committee.scss';
import SEO from "../components/seo"

const committee = ({data}) => {
    
    
    
    return (
        <Layout title="Ignite Summit Committee" >
            <SEO title="Ignite Summit Committee" />
            <div className="container" >
            {data.allCommitteeJson.nodes.map(m => (
                <article className="committee-member" key={m.name.toString()}>
                    <div className="img-wrapper"><Img alt={m.name} fluid={m.headshot.childImageSharp.fluid} /></div>
                    <div className="txt-wrapper">
                        <h3>{m.name}</h3>
                        <div className="positions">
                            <span>{m.apacheTitle}</span><br />
                            <span>{m.jobTitle}</span>
                        </div>
                        <p>{m.bio}</p>
                        <ul className="social">
                            {m.linkedin && 
                            <li><a href={`https://www.linkedin.com/in/${m.linkedin}/`} target="_blank" rel="noreferrer"><img alt="Linkedin icon" src={linkedinIcon} height="512" width="448" />{m.linkedin}</a></li>
                            }

                            {m.github && 
                            <li><a href={`https://github.com/${m.github}`} target="_blank" rel="noreferrer"><img alt="Github icon" src={githubIcon} height="512" width="448" /> {m.github}</a></li>
                            }

                            {m.twitter && 
                            <li><a href={`https://twitter.com/${m.twitter}`} target="_blank" rel="noreferrer"><img alt="Twitter icon" src={twitterIcon} height="512" width="448" />{m.twitter}</a></li>
                            }
                        </ul>
                    </div>
                </article>
            ))}
            </div></Layout>
        
    )
}

export const committeeMembersData = graphql`
        query CommitteeMembersQuery {
            allCommitteeJson {
                nodes {
                    name
                    apacheTitle
                    bio
                    github
                    jobTitle
                    linkedin
                    twitter
                    headshot {
                        childImageSharp {
                            fluid(maxWidth: 330) {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
            }
        }  
    `

export default committee